module.exports = __webpack_public_path__ + "static/img/dingzhi.84c4aab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dingzhi.png
// module id = MQrR
// module chunks = 1